import styled from 'styled-components'
import theme from 'theme_'
import { Font16 } from 'components/Typography'

export const HomeSoftwareVersionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: ${theme.spacing.xs};
  margin-top: ${theme.spacing.s};
  margin-bottom: ${theme.spacing.md};
  @media ${theme.devices.tablet} {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: ${theme.spacing.base};
    margin-top: ${theme.spacing.sm};
    margin-bottom: ${theme.spacing.xl};
  }
`

export const HomeSoftwareVersionLabel = styled.div`
  ${Font16};
  font-weight: 900;
`

export const HomeSoftwareVersionValue = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  gap: 16px;
  background: ${theme.colors.lightGrey};
  border-radius: 8px;
  ${Font16};
  font-weight: 900;
`

export const HomeSoftwareTitle = styled.div`
  font-size: 20px;
  font-weight: 900;
`

export const HomeSoftwareEmptyBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 96px;
  color: ${theme.colors.darkeyGrey};
  background: ${theme.colors.white};
  border-radius: 8px;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.02);
`

export const HomeSoftwareUpdateTableContainer = styled.div`
  @media ${theme.devices.tablet} {
    > div {
      min-width: fit-content;
    }
  }
`
